var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClearFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C12 2.44772 11.5523 2 11 2H2.00001C1.61069 2 1.25675 2.22596 1.0929 2.57912C0.929037 2.93229 0.985046 3.34845 1.23644 3.64573L9.00001 12.8261V19C9.00001 19.3788 9.21402 19.725 9.5528 19.8944L13.5528 21.8944C13.8628 22.0494 14.2309 22.0329 14.5257 21.8507C14.8206 21.6684 15 21.3466 15 21V13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13V19.382L11 18.382L11 12.4548C10.9988 12.2202 10.9151 11.9935 10.7636 11.8143L4.15532 4H11C11.5523 4 12 3.55228 12 3Z",
    fill: "#2F363D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5528 1.99999C14.9433 1.60946 15.5765 1.60946 15.967 1.99999L18.2599 4.29288L20.5528 1.99999C20.9433 1.60946 21.5765 1.60946 21.967 1.99999C22.3575 2.39051 22.3575 3.02368 21.967 3.4142L19.6741 5.70709L21.967 7.99999C22.3575 8.39051 22.3575 9.02367 21.967 9.4142C21.5765 9.80472 20.9433 9.80472 20.5528 9.4142L18.2599 7.12131L15.967 9.4142C15.5765 9.80472 14.9433 9.80472 14.5528 9.4142C14.1623 9.02367 14.1623 8.39051 14.5528 7.99999L16.8457 5.70709L14.5528 3.4142C14.1623 3.02368 14.1623 2.39051 14.5528 1.99999Z",
    fill: "#2F363D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFilter);
export default __webpack_public_path__ + "static/media/Clear_filter.2d9c550262bed3dab94ed295d3dbe19b.svg";
export { ForwardRef as ReactComponent };